import React from 'react';
import { Button, CardGroup, ContentCard, InfoCard, Paper, QuoteCard } from 'library';

import './CardGroupBlock.scss';

const SupportedCards = {
  InfoCard: InfoCard,
  ContentCard: ContentCard,
  QuoteCard: QuoteCard,
};

const CardGroupBlock = ({ theme = 'dark', heading, text, cardType, ctaButton = {}, cards = [] }) => {
  const CardComponent = SupportedCards[cardType];

  if (!CardComponent || cards.length === 0) {
    return null;
  }

  return (
    <div className="CardGroupBlock">
      <Paper theme={theme} pad={{ bottom: 4 }}>
        <CardGroup cardSize={CardComponent.size} title={heading} text={text} preventOrphans>
          {cards.map((cardProps, index) => (
            <CardComponent key={cardProps.key || cardProps.title || cardProps.link || index} {...cardProps} />
          ))}
        </CardGroup>

        {ctaButton?.url && (
          <Button theme={ctaButton.style} href={ctaButton.url} className={ctaButton.classes}>
            {ctaButton.text}
          </Button>
        )}
      </Paper>
    </div>
  );
};

export default CardGroupBlock;
